import { Component, OnInit, Input } from '@angular/core';
import { AccountService } from '@app/services/account.service';
import { ListComponent } from '@app/common/templates/list/list.component';
import { environment } from '@environments/environment';

@Component({
    selector: 'common-list-view-elements',
    templateUrl: './common-list-view-elements.html',
    styleUrls: ['./common-list-view-elements.scss']
})

export class CommonListViewElementsComponent implements OnInit {
    env_supportmail: string = '';
    @Input() accountService?: AccountService;
    @Input() loading?: number;
    @Input() parent?: ListComponent;

  constructor() {
    this.env_supportmail = environment.supportEmail;
		if(!this.env_supportmail || this.env_supportmail.trim().length < 1) {
			this.env_supportmail = 'support@visy-gmbh.com';
		}
  }

    ngOnInit(): void {
    }

}
